import * as React from "react";
import * as ReactDOM from "react-dom";
import 'whatwg-fetch';

const Opened_BodyClass = "hide-body-scroll";
const ButtonMenuId = "workflowQuickAddIssueBtn";

function lazyWithPreload(factory) {
	const Component: any = React.lazy(factory);
	Component.preload = factory;
	return Component;
}

const QuickAddIssuePanel = lazyWithPreload(() => import(/* webpackChunkName: "quickAddIssuePanel" */ './QuickAddIssuePanel'));

class QuickAddIssue extends React.Component<{}, any> {
	constructor(params) {
		super(params);
		this._element = React.createRef();
		this.state = {
			open: false,
			loaded: false,
		}
	}

	_element: any;

	componentDidMount() {

		let btn = document.getElementById(ButtonMenuId);
		if (btn) {
			btn.addEventListener("click", (e) => {
				if (this.state.open) {
					this.close();
				} else {
					this.open();
				}
			});

			btn.addEventListener("mouseenter", () => {
				this.setState({ loaded: true });
				QuickAddIssuePanel.preload();
			});
		}

		document.addEventListener("click", (e) => {
			if (this.state.open) {
				if (!this._element.current || !this._element.current.contains(e.target)) {
					if (!btn || !btn.contains(e.target as Node)) {
						this.close();
					}
				}
			}
		});
	}

	open() {
		if (!this.state.open) {
			document.body.classList.add(Opened_BodyClass);

			this.setState({ open: true, loaded: true });

			let btn = document.getElementById(ButtonMenuId);
			btn.classList.add("active");
		}
	}

	close() {
		if (this.state.open) {
			document.body.classList.remove(Opened_BodyClass);
			
			this.setState({ open: false });

			let btn = document.getElementById(ButtonMenuId);
			btn.classList.remove("active");
		}
	}

	handleOnClose() {
		this.close();
	}

	render() {

		if (this.state.loaded) {

			let style = { display: "none" };
			if (this.state.open) {
				style = null;
			}

			return <div style={style} ref={this._element} >
				<React.Suspense fallback={null}>
					<QuickAddIssuePanel onClose={this.handleOnClose.bind(this)} />
				</React.Suspense>
			</div>;
		}
		return null;
	}
}

export default function Init() {
	let content = document.getElementById("workflowQuickAddIssue");
	var quickAddIssue: any = ReactDOM.render(<QuickAddIssue />, content);

	let qdesk = (window as any).qdesk;
	qdesk.header = {
		openAddIssuesCatalog: function () {
			quickAddIssue.open();
		},
		closeAddIssuesCatalog: function () {
			quickAddIssue.close();
		}
	};
}